import React from 'react';
import Typography from "../../../../components/Typography";
import {MuiTextField} from "../../../../components/MuiComponents/FormInputs";
import {authentication_code, otp, required_message} from "../../../../utils/validations";
import {useForm} from "react-hook-form";
import Button from "../../../../components/Button";
import {useMutation} from "react-query";
import {verify2FaToken} from "../../../../api/mutations/auth";
import {useDispatch, useSelector} from "react-redux";
import {setAuthInputs, setFormError} from "../../../../redux/reducers/auth";
import MainLoader from "../../../../components/Loader/MainLoader";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const Otp = ({setScreen}) => {
    const {register, handleSubmit, formState: {errors}} = useForm()
    const {token, formErrors, user} = useSelector(state => state.auth)
    const dispatch = useDispatch()
    const mutation = useMutation(verify2FaToken)
    const submit = async (data) => {
        try {
            let res = await mutation.mutateAsync({
                auth_token: token,
                token: data.otp
            })
            if (res.authenticated) {
                setScreen("success")
                dispatch(setAuthInputs({
                    token: res.token
                }))
            }
        } catch (e) {
            dispatch(setFormError({
                _2faOtp: e?.response?.data?.message || "error"
            }))
        }
    }
    let disabled = Object.keys(errors).length > 0
    return (
        <div className={"relative"}>
            {mutation.isLoading && <MainLoader/>}
            {!user.tfa_enabled && <Button variant={"text"} className={"absolute -top-1 left-0 !text-body !p-0"}
                                          onClick={() => setScreen("qr_screen")}
            >
                <ChevronLeftIcon style={{
                    height: 20,
                    width: 20,
                    verticalAlign: "bottom"
                }}/>Back</Button>}
            <form onSubmit={handleSubmit(submit)}>
                <Typography variant={"h4"} className={"text-primary-800 pb-2.5"}>Two Factor Authentication</Typography>
                <Typography variant={"body1"}>Enter the code generated by your <nobr>authenticator app</nobr>
                </Typography>
                <MuiTextField label={"Enter authentication code"}
                              InputProps={{...register("otp", {required: required_message, ...authentication_code})}}
                              error={Boolean(errors?.otp)}
                              helperText={errors?.otp?.message}
                              type={"password"}
                />
                <Typography className={"text-functional-red"}>{formErrors?._2faOtp}</Typography>
                <Button disabled={disabled} className={"mt-[20px]"}>Verify</Button>
            </form>
        </div>
    );
};

export default Otp;
